import { selectIsPublicationAvailable, selectIsPublishButtonPending } from '.';
import { IAppState } from '../../redux';
import { selectIsSaveDraftPending } from '../draft';
import { selectServiceUnavailableReason } from '../publishTerms';

export function selectIsPublishButtonDisabled(state: IAppState): boolean {
  const isPublishButtonPending = selectIsPublishButtonPending(state);
  const isPublicationAvailable = selectIsPublicationAvailable(state);
  const isSaveDraftPending = selectIsSaveDraftPending(state);
  const unavailableReason = selectServiceUnavailableReason(state);

  return (
    isPublishButtonPending ||
    isSaveDraftPending ||
    // Если публикация недоступна, но под услугами есть ошибка, кнопку блокировать не нужно, т.к. при клике на нее скроллим к ошибке
    (!isPublicationAvailable && !unavailableReason)
  );
}
